var mixin = {
  props: {
    onClick: {
      type: Function,
      default: undefined
    }
  },
  created: function created() {
    var _this = this;
    this.$lmBus && this.$lmBus.$on('lmClick', function (event) {
      if (_this.onClick) {
        _this.onClick(event);
      }
    });
  }
};
export default mixin;